import React, { Component } from "react";
import { withFormsy } from "formsy-react";
import { Alert, Button } from "reactstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Spinner } from "../Shared";
import { MySelect } from "../Shared/Forms";

import { coreActions } from "./actions/core.actions";

export class CoreCurrencies extends Component {
  componentDidMount() {
    this.getCoreCurrencies();
  }

  getCoreCurrencies = () => {
    this.props.getCoreCurrencies();
  };

  render() {
    const { fetching, response, error, name, value, disabled } = this.props;

    const selectedValue =
      response && response.modelList.filter(currency => currency.alphaCode === value);
    return (
      <div>
      {fetching ? (
        <Alert color="info">
          <Spinner message="Fetching Currencies" />
        </Alert>
      ) : (
        <div>
          <MySelect
            name={name}
            value={selectedValue && selectedValue[0]}
            title="Currency"
            options={response ? response.modelList : []}
            valueKey="alphaCode"
            disabled={disabled}
            labelKey="name"
            validating={fetching}
            innerRef={c => {
              this.currencyCode = c;
            }}
            isClearable={true}
            required
          />
          {!response && error && (
            <Alert color="danger">
              {error.message}
              <div className="text-reight">
                <Button color="danger" onClick={this.getCoreCurrencies}>
                  Retry
                </Button>
              </div>
            </Alert>
          )}
        </div>
      )}
    </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, response, error } = state.coreCurrencies;
  return {
    fetching,
    fetched,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCoreCurrencies: bindActionCreators(
      coreActions.getCoreCurrencies,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withFormsy(CoreCurrencies));
